import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDash(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 1H12" stroke="currentColor" strokeWidth="2" />
    </SVGIcon>
  );
}
